<template>
<!-- SECTION Expeditions-->
  <div id="expeditionsSection" class="col-12 justify-content-center pe-3"
  :class="(visibility.sideMenu)?'section-container-sm' :'section-container-lg'">
    <div class="col-12 p-0 m-0 bg-caja section-container rounded-5">
  
<!-- HEADER Expeditions -->

      <div class="row overflow-hidden col-12 m-0 p-0 text-white bg-clomos rounded-top-5 pb-1 h-100" >

        <div class="col-lg-9 col-md-12 col-12 justify-content-center" style="display: inherit">
          <!--<ion-icon v-if="session.user.bookmark==='expeditions'" name="bookmark" class="bookmark-button"></ion-icon>
          <ion-icon v-else name="bookmark-outline" class="bookmark-button"></ion-icon>-->
          <h4 class="tx-left tx-clomos-white text-nowrap mb-2 ps-1 pt-2" style="height:40px;">

            <ion-icon name="arrow-redo-outline" class="tx-27 me-2 align-bottom"></ion-icon>
            {{dictionary["Expedición de productos"][session.user.language]}}
          </h4>
        </div>

        <div class="col-lg-3 col-12 p-2 pb-1">	
          <button id="btnDisplayNewExpeditionModal"
          class="btn btn-clomos bg-white rounded p-1 inner-border fw-normal text-nowrap"
          style="width: 100%; height:100%; vertical-align: middle; border: solid 2px white"
          @click="toggleNewExpeditionModal">
              <ion-icon name="add-circle-outline" class="tx-clomos-dark me-2 tx-20" style="vertical-align: middle; margin-top: -0.25rem;"></ion-icon>
              <span class="ms-auto tx-clomos-dark">{{dictionary["Solicitar expedición"][session.user.language]}}</span>
          </button>
        </div>
      </div>

      <div class="m-0 p-3 overflow-auto">
        <table id="expeditionsDataTable" class="display w-100 border-1 p-0 m-0 rounded-3">
          <thead class="bg-clomos-light">
            <tr>
              <th v-for="column in expeditionsColumns" :key="column.data"
              :width="column.width" class="tx-black fw-medium text-nowrap">
                {{dictionary[column.text][session.user.language]}}
              </th>
            </tr>
          </thead>
        </table>
      </div>

    </div>
  </div>

<!-- MODAL New Expedition -->
  <NewExpeditionModal
  v-if="display.newExpeditionModal"
  :session="session"
  :dictionary="dictionary"
  :countries="countries"
  :timeZones="timeZones"
  :currentCompany="currentCompany"
  :availableCompanies="availableCompanies"
  :hasReceipt="true"
  v-on:toggleNewExpeditionModal="toggleNewExpeditionModal">
  </NewExpeditionModal> 

<!-- MODAL Prepare Expedition -->
  <PrepareExpeditionModal
  v-if="display.prepareExpeditionModal"
  :session="session"
  :dictionary="dictionary"
  :countries="countries"
  :timeZones="timeZones"
  :currentCompany="currentCompany"
  :availableCompanies="availableCompanies"
  :expeditionId="targetExpeditionId"
  v-on:togglePrepareExpeditionModal="togglePrepareExpeditionModal">
  </PrepareExpeditionModal> 

<!-- MODAL Generar Etiquetas -->
  <GenerarEtiquetas
  v-if="display.orderLabelsModal"
  :session="session"
  :dictionary="dictionary"
  :countries="countries"
  :timeZones="timeZones"
  :currentCompany="currentCompany"
  :availableCompanies="availableCompanies"
  :orderId="targetExpeditionId"
  :orderData="targetExpedition"
  v-on:toggleOrderLabelsModal="toggleExpeditionLabelsModal">
</GenerarEtiquetas>

<!-- MODAL Plan Text Alert -->
  <TextAlertModal
  v-if="display.planExpeditionModal"
  :session="session"
  :dictionary="dictionary"
  :countries="countries"
  :alertHeader="dictionary['Planificar'][session.user.language]+': '"
  :alertTarget="targetExpeditionId"
  :alertInput="(session.browser === 'firefox') ?'date' :'datetime-local'"
  :alertValue="alertValue"
  v-on:updateAlertValue="onUpdateAlertValue"
  v-on:acceptAlert="onPlanExpedition"
  v-on:dismissAlert="togglePlanExpeditionModal">
  </TextAlertModal>

<!-- MODAL End Text Alert -->
  <TextAlertModal
  v-if="display.endExpeditionModal"
  :session="session"
  :dictionary="dictionary"
  :countries="countries"
  :alertHeader="dictionary['Expedir'][session.user.language]+': '"
  :alertTarget="targetExpeditionId"
  v-on:acceptAlert="onEndExpedition"
  v-on:dismissAlert="toggleEndExpeditionModal">
  </TextAlertModal>

<!-- MODAL Delete Text Alert -->
  <TextAlertModal
  v-if="display.deleteExpeditionModal"
  :session="session"
  :dictionary="dictionary"
  :countries="countries"
  :alertHeader="dictionary['Expedición a eliminar'][session.user.language]+': '"
  :alertTarget="targetExpeditionId"
  v-on:acceptAlert="onDeleteExpedition"
  v-on:dismissAlert="toggleDeleteExpeditionModal">
  </TextAlertModal>

</template>

<script>
import $ from 'jquery';
import NewExpeditionModal from '@/components/expeditions/NewExpeditionModal';
import PrepareExpeditionModal from '@/components/expeditions/PrepareExpeditionModal';
import GenerarEtiquetas from '@/components/expeditions/GenerarEtiquetas';
import TextAlertModal from '@/components/other/TextAlertModal';
// Clomos
import api from '@/services/api';

export default {
  name: "ExpeditionsComponent",
  components: { PrepareExpeditionModal, NewExpeditionModal, GenerarEtiquetas, TextAlertModal  },
  props: {
    session: {
      type: Object,
      requiered: true,
    },
    dictionary: {
      type: Object,
      requiered: true,
    },
    countries: {
      type: Object,
      requiered: true,
    },
    timeZones: {
      type: Object,
      requiered: true,
    },
    currentCompany: {
      type: Object,
      requiered: true,
    },
    availableCompanies: {
      type: Object,
      requiered: true,
    },
    visibility: {
      type: Object,
      requiered: true,
    },
    dataTableOptions: {
      type: Object,
      requiered: true,
    }
  },
  watch: { 
    currentCompany: async function() {
      await this.getExpeditionList();
      this.displayExpeditionsDataTable();
    }
  },
  data() {
    return {
      expeditionsColumns: [
        {text:"Albarán", data: "expeditionId", width: "5%",
          render: (data) => {
            return "<ion-icon name='list-circle-outline' data-id="+data+" class='btnDetailExpedition btn tx-24 tx-primary  p-0 m-0'></ion-icon>";
          }
        },
        {text:"Identificador", data: "expeditionId", width: "15%"},
        {text:"Estado", data: "expeditionStatus", width: "10%",
          render: (data) => {
            switch (data.status) {
              case "0":
                return this.dictionary["Nueva"][this.session.user.language];
              case "1":
                return this.dictionary["Planificada"][this.session.user.language];
              case "2":
                return this.dictionary["Ejecutando"][this.session.user.language];
              case "3":
                return this.dictionary["Ejecutada"][this.session.user.language];
              case "4":
                return this.dictionary["Finalizada"][this.session.user.language];
              case "5":
                return this.dictionary["Cancelada"][this.session.user.language];
              default:
                return data.status
            }
          }        
        },
        {text:"Tipo", data: "expeditionType", width: "10%",
          render: (data) => {
            switch (data) {
              case "0":
                return "Entrada";
              case "1":
                return "Salida";
              case "2":
                return "Regularización";
              case "3":
                return "Devolución";
              case "4":
                return "Pedido";
            }
          }
        },
        {text:"Fecha de creación", data: "expeditionCreationDateTime", width: "10%",
          render: (data) => {   
            return "<span style='display: none;'>" + data.getTime() + "</span> <spam>" + this.parseDateUserTimezone(data) + "</spam>";
          }
        },
        {text:"Planificar", data: "expeditionStatus", width: "5%",
          render: (data) => {
            return (Number(data.status)===0)
              ? "<ion-icon name='chevron-forward-circle-outline' data-id="+data.id+" class='btnPlanExpedition btn tx-24 tx-primary p-0 m-0'></ion-icon>"
              : "<ion-icon name='checkmark-circle-outline' data-id="+data.id+" class='btnPlannedExpedition btn tx-24 tx-success p-0 m-0' disabled></ion-icon>";
          }
        },
        {text:"Preparar", data: "expeditionStatus", width: "5%",
          render: (data) => {
            if (Number(data.status)==5)
            {
              return  "<ion-icon name='close-circle-outline' data-id="+data.id+" class='btnPrepareExpedition btn tx-24 tx-danger p-0 m-0' disabled></ion-icon>";
            }
            return (Number(data.status)<1)
              ? "<ion-icon name='chevron-forward-circle-outline' data-id="+data.id+" class='btn tx-24 tx-clomos-midtone opacity-50 p-0 m-0' disabled></ion-icon>"
              : (Number(data.status)===1 || Number(data.status)===2)
                ? "<ion-icon name='chevron-forward-circle-outline' data-id="+data.id+" class='btnPrepareExpedition btn tx-24 tx-primary p-0 m-0'></ion-icon>"
                : "<ion-icon name='checkmark-circle-outline' data-id="+data.id+" class='btnPrepareExpedition btn tx-24 tx-success p-0 m-0'></ion-icon>";
          }
        },
        {text:"Etiqueta", data: "expeditionObject", width: "5%",
          render: (data) => {
            if (Number(data.status)==5)
            {
              return  "<ion-icon name='document-text-outline' data-id="+data.id+" class='btn tx-24 tx-clomos-midtone opacity-50 p-0 m-0' disabled></ion-icon>";
            }

            return (Number(data.status)<3 
            || data.params === undefined
            || data.summary === undefined 
            || data.summary === "")
              ? "<ion-icon name='document-text-outline' data-id="+data.id+" class='btn tx-24 tx-clomos-midtone opacity-50 p-0 m-0' disabled></ion-icon>"
              : "<ion-icon name='document-text-outline' data-id="+data.id+" class='btnDisplayExpeditionLabels btn tx-24 tx-success p-0 m-0'></ion-icon>";
          }
        },
        {text:"Expedir", data: "expeditionStatus", width: "5%",
          render: (data) => {
            if (Number(data.status)==5)
            {
              return  "<ion-icon name='chevron-forward-circle-outline' data-id="+data.id+" class='btn tx-24 tx-clomos-midtone opacity-50 p-0 m-0' disabled></ion-icon>";
            }
            return (Number(data.status)<3)
              ? "<ion-icon name='chevron-forward-circle-outline' data-id="+data.id+" class='btn tx-24 tx-clomos-midtone opacity-50 p-0 m-0' disabled></ion-icon>"
              : (Number(data.status)===3)
                ? "<ion-icon name='chevron-forward-circle-outline' data-id="+data.id+" class='btnEndExpedition btn tx-24 tx-primary p-0 m-0'></ion-icon>"
                : "<ion-icon name='checkmark-circle-outline' data-id="+data.id+" class='btnExecutedExpedition btn tx-24 tx-success p-0 m-0' disabled></ion-icon>";
          }
        },
        {text:"Eliminar", data: "expeditionStatus", width: "5%",
          render: (data) => {
            return (Number(data.status)===0)
              ? "<ion-icon name='trash-outline' data-id="+data.id+" class='btnDeleteExpedition btn tx-24 tx-primary p-0 m-0'></ion-icon>"
              : "<ion-icon name='trash-outline' data-id="+data.id+" class='btn tx-24 tx-clomos-midtone opacity-50 p-0 m-0' disabled></ion-icon>";
          }
        }
      ],
      targetExpeditionId: "",
      expeditionList: [],
      alertValue: '',
      bulgeInput: {
        volume: {
          height: 0,
          width: 0,
          depth: 0
        },
        units: 0
      },
      bulgeList: [],
      display: {
        newExpeditionModal: false,
        planExpeditionModal: false,
        prepareExpeditionModal: false,
        orderLabelsModal: false,
        endExpeditionModal: false,
        deleteExpeditionModal: false
      }
    }
  },
  computed: {
    targetExpedition() {
      for (let i in this.expeditionList) {
        if (this.expeditionList[i].id === this.targetExpeditionId)
          return this.expeditionList[i];
      }
      return {};
    }
  },
  emits: ["setCurrentCompany", "getAvailableCompanies"],
  methods: {
    // DISPLAY
    parseDateUserTimezone(date) {
      let formatedDate = "-";
      let parsedDate = (date!="")
        ?this.$dayjs(date).utc("z").local().tz(this.session.user.dateTimeZone).$d
        :""; 
      if (parsedDate!="") {
        let d = new Date(parsedDate);
        switch (this.session.user.dateTimeFormat) {
          case "DD/MM/YYYY": 
            formatedDate = String(d.getDate()).padStart(2,"0")+"/"+String((d.getMonth()+1)).padStart(2,"0")+"/"+String(d.getFullYear())+" "+String(d.getHours()).padStart(2,"0")+":"+String(d.getMinutes()).padStart(2,"0");
            break;
          case "MM/DD/YYYY": 
            formatedDate = String((d.getMonth()+1)).padStart(2,"0")+"/"+String(d.getDate()).padStart(2,"0")+"/"+String(d.getFullYear())+" "+String(d.getHours()).padStart(2,"0")+":"+String(d.getMinutes()).padStart(2,"0");
            break;
          default:
            formatedDate = String((d.getMonth()+1)).padStart(2,"0")+"/"+String(d.getDate()).padStart(2,"0")+"/"+String(d.getFullYear())+" "+String(d.getHours()).padStart(2,"0")+":"+String(d.getMinutes()).padStart(2,"0");
            break;
        }
      }
      return formatedDate;
    },
    onCurrentCompanyChanged(event) {
      let value = event.target.value;
      this.$router.replace({params: {currentCompanyNifCif: value}})
      this.$emit('setCurrentCompany',value);
    },
    displayExpeditionsDataTable() {
      $("#expeditionsDataTable").DataTable().clear()
      for (let i in this.expeditionList) {
        $("#expeditionsDataTable").DataTable().rows.add([{
          expeditionObject: this.expeditionList[i],
          expeditionId: this.expeditionList[i].id, 
          expeditionType: this.expeditionList[i].type,
          expeditionStatus: {id: this.expeditionList[i].id, status: this.expeditionList[i].status, plannedDateTime: this.expeditionList[i].plannedDateTime}, 
          expeditionExecutionDateTime: (this.expeditionList[i].executionDateTime != undefined) ? new Date(this.expeditionList[i].executionDateTime) : "",
          expeditionCreationDateTime: (this.expeditionList[i].creationDateTime != undefined) ? new Date(this.expeditionList[i].creationDateTime) : "",
          expeditionPlannedDateTime: (this.expeditionList[i].plannedDateTime != undefined) ? new Date(this.expeditionList[i].plannedDateTime) : "",
          expeditionExecutionEndDateTime: (this.expeditionList[i].executionEndDateTime != undefined) ? new Date(this.expeditionList[i].executionEndDateTime) : ""
        }]);
      }
      $("#expeditionsDataTable").DataTable().draw();
      this.setButtonFunctions();
      if($(".dataTables_paginate").get()[0] != undefined) $(".dataTables_paginate").get()[0].addEventListener('click', this.setButtonFunctions);
      $(".sorting").get().forEach((btn)=> { btn.addEventListener('click', this.setButtonFunctions)});
    },
    async toggleNewExpeditionModal() {
      if (this.display.newExpeditionModal) {
        await this.getExpeditionList();
        this.displayExpeditionsDataTable();
      }
      this.display.newExpeditionModal = !this.display.newExpeditionModal;
    },
    async togglePlanExpeditionModal() {
      if (this.display.planExpeditionModal) {
        await this.getExpeditionList();
        this.displayExpeditionsDataTable();
      }
      this.display.planExpeditionModal = !this.display.planExpeditionModal;
    },
    async togglePrepareExpeditionModal() {
      if (this.display.prepareExpeditionModal) {
        await this.getExpeditionList();
        this.displayExpeditionsDataTable();
      }
      this.display.prepareExpeditionModal = !this.display.prepareExpeditionModal;
    },
    async toggleExpeditionLabelsModal() {
      if (this.display.orderLabelsModal) {
        await this.getExpeditionList();
        this.displayExpeditionsDataTable();
      }
      else if (this.targetExpedition.params === undefined
      || this.targetExpedition.summary === undefined 
      || this.targetExpedition.summary === "") {
        return;
      }
      this.display.orderLabelsModal = !this.display.orderLabelsModal;
    },
    async toggleEndExpeditionModal() {
      if (this.display.endExpeditionModal) {
        await this.getExpeditionList();
        this.displayExpeditionsDataTable();
      }
      this.display.endExpeditionModal = !this.display.endExpeditionModal;
    },
    async toggleDeleteExpeditionModal() {
      if (this.display.deleteExpeditionModal) {
        await this.getExpeditionList();
        this.displayExpeditionsDataTable();
      }
      this.display.deleteExpeditionModal = !this.display.deleteExpeditionModal;
    },
    // BUTTONS
    setButtonFunctions() {
      setTimeout(()=>{
        $(".btnTargetExpedition").get().forEach(btn => {
          btn.addEventListener('click', this.onTargetExpedition);
        });
        $(".btnDetailExpedition").get().forEach(btn => {
          btn.addEventListener('click', this.onDetailExpedition)
        });
        $(".btnPlanExpedition").get().forEach(btn => {
          btn.addEventListener('click', this.onPlanExpedition);
        }); 
        $(".btnPrepareExpedition").get().forEach(btn => {
          btn.addEventListener('click', this.onPrepareExpedition);
        }); 
        $(".btnDisplayExpeditionLabels").get().forEach(btn => {
          btn.addEventListener('click', this.onDisplayExpeditionLabels);
        }); 
        $(".btnEndExpedition").get().forEach(btn => {
          btn.addEventListener('click', this.onEndExpedition);
        });
        $(".btnDeleteExpedition").get().forEach(btn => {
          btn.addEventListener('click', this.onDeleteExpedition);
        });
      }, 300);
    },
    // GET
    async getExpeditionList(callback) {
      let request = {
        nifCif: this.session.user.nifCif
      };
      let withdrawListResponse = await api.getExpeditionList(request);
      let withdrawList = api.parseOrdersFromResponse(withdrawListResponse)
      let orderListResponse = await api.getOrderList(request);
      let orderList = api.parseOrdersFromResponse(orderListResponse);

      this.expeditionList = withdrawList.concat(orderList);

      if (callback && typeof callback === "function") callback(this.expeditionList);
    },
    // TARGET 
    onTargetExpedition(event) {
      console.log('TARGET WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetExpeditionId = event.target.getAttribute('data-id');
    },
    // PLAN
    onUpdateAlertValue(value) {
      this.alertValue = value;
    },
    async onPlanExpedition(event) {
      if (!this.display.planExpeditionModal) {
        console.log('PLAN WHERE ID:');
        console.log(event.target.getAttribute('data-id'));
        this.targetExpeditionId = event.target.getAttribute('data-id');
      }
      else {
        if (this.alertValue==='') this.alertValue = new Date();
        let statusData = {
          orderId : this.targetExpeditionId,
          dateTime : this.alertValue,
          status : 1
        }
        let response = await api.setOrderStatus(statusData);
        if (response["status-code"] === "200") {
          window.alert("La expedición ha sido planeada satisfactoriamente.");
        }
        else {
          window.alert("Error al planear el expedición.");
        }
      }
      this.togglePlanExpeditionModal();
    },
    // PREPARE
    onPrepareExpedition(event) {
      console.log('PREPARE WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetExpeditionId = event.target.getAttribute('data-id')
      this.togglePrepareExpeditionModal();
    },
    // LABELS
    onDisplayExpeditionLabels(event) {
      console.log('SHOW LABELS FOR ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetExpeditionId = event.target.getAttribute('data-id');
      this.toggleExpeditionLabelsModal();
    },
    // DETAILS
    onDetailExpedition(event) {
      console.log('DETAIL WHERE ID:');
      console.log(event.target.getAttribute('data-id'));
      this.targetExpeditionId = event.target.getAttribute('data-id')
      var tr = $(event.target).closest('tr');
      var row = $("#expeditionsDataTable").DataTable().row(tr);
      if (row.child.isShown()) {
        event.target.name = "list-circle-outline";
        row.child.hide();
        tr.removeClass('shown');
      } 
      else {
        event.target.name = "chevron-up-circle-outline";
        let content = '' 
        if (this.targetExpedition.summary != "") {
          content = content + '<div class="ms-auto me-auto mb-1 p-0 border-1 overflow-auto"> <text class="tx-bold pe-1">ID Pedido:</text>'+JSON.parse(this.targetExpedition.summary)["idPedido"] +' </div>';
        }
        content = content +
          '<table id="detailTable'+this.targetExpeditionId+'" cellspacing="0" class="border-1" style="width:100%; margin: 0;">' +
            '<tr>' +
              '<td class="tx-bold col-3">Referencia</td>' +
              '<td class="tx-bold">Nombre</td>' +
              '<td class="tx-bold">Cantidad</td>' +
              '<td class="tx-bold">Lote</td>' +
              '<td class="tx-bold">Nº de serie</td>' +
              '<td class="tx-bold">Talla</td>' +
              '<td class="tx-bold">Color</td>' +
              '<td class="tx-bold">Fecha de caducidad</td>' +
            '</tr>';
          for (let i in this.targetExpedition.params.productos) {
            let product = this.targetExpedition.params.productos[i];
            content = content + '<tr>';
              if (product.referencia!=undefined&&product.referencia!="") content = content + '<td>' + product.referencia + '</td>'
                else content = content + '<td>-</td>';
              if (product.etiqueta!=undefined&&product.etiqueta!="") content = content + '<td>' + product.etiqueta + '</td>'
                else content = content + '<td>-</td>';
              if (product.unidades!=undefined&&product.unidades!="") content = content + '<td>' + product.unidades + '</td>'
                else content = content + '<td>-</td>';
              if (product.lote!=undefined&&product.lote!="") content = content + '<td>' + product.lote + '</td>'
                else content = content + '<td>-</td>';
              if (product.numeroSerie!=undefined&&product.numeroSerie!="") content = content + '<td>' + product.numeroSerie + '</td>'
                else content = content + '<td>-</td>';
              if (product.talla!=undefined&&product.talla!="") content = content + '<td>' + product.talla + '</td>'
                else content = content + '<td>-</td>';
              if (product.color!=undefined&&product.color!="") content = content + '<td>' + product.color + '</td>'
                else content = content + '<td>-</td>';
              if (product.fechaCaducidad!=undefined&&product.fechaCaducidad!="") content = content + '<td>' + product.fechaCaducidad + '</td>'
                else content = content + '<td>-</td>';
            '</tr>';
          }
          content = content + '</table>';
        row.child(content).show();
        document.getElementById('detailTable'+this.targetExpeditionId).parentNode.style.padding = 0;
        tr.addClass('shown');
      }
    },
    // END
    async onEndExpedition(event) {
      if (!this.display.endExpeditionModal) {
        console.log('END WHERE ID:');
        console.log(event.target.getAttribute('data-id'));
        this.targetExpeditionId = event.target.getAttribute('data-id');
      }
      else {
        let statusData = {
          orderId : this.targetExpeditionId,
          dateTime : new Date(),
          status : 4
        }
        let response = await api.setOrderStatus(statusData);
        if (response["status-code"] === "200") {
          this.$emit('toggleNewExpeditionModal');
          window.alert("La expedición ha finalizado satisfactoriamente.");
        }
        else {
          window.alert("Error al finalizar la expedición.");
        }
      }
      this.toggleEndExpeditionModal();
    },
    // DELETE
    async onDeleteExpedition(event) {
      if (!this.display.deleteExpeditionModal) {
        console.log('DELETE WHERE ID:');
        console.log(event.target.getAttribute('data-id'));
        this.targetExpeditionId = event.target.getAttribute('data-id');
      }
      else {
        let response = await api.deleteOrder(this.targetExpeditionId);
        if (response["status-code"] === "200") {
          this.$emit('toggleNewExpeditionModal');
          window.alert("La expedición ha sido eliminada satisfactoriamente.");
        }
        else {
          window.alert("Error al eliminar la expedición.");
        }
      }
      this.toggleDeleteExpeditionModal();
    }
  },
  async created() {
    await this.getExpeditionList()
    this.$emit('getAvailableCompanies',(this.displayExpeditionsDataTable));
  },
  mounted() {
    $("#expeditionsDataTable").DataTable(
      {
        pagingType: 'full_numbers',
        pageLength: 10,
        processing: true,
        dom: 'Bfrtip',
        buttons: [
          { "extend": 'colvis', "className": 'btn' },
          { "extend": 'copy', "className": 'btn ms-auto' },
          { "extend": 'csv', "className": 'btn' },
          { "extend": 'print', "className": 'btn me-0' },
        ],
        columns: this.expeditionsColumns,
        select: this.dataTableOptions.select,
        language: this.dataTableOptions.language[this.session.user.language],
        //stateSave: this.dataTableOptions.stateSave,
        order: [[4,'desc']]
      }
    );
    $(".dataTables_filter").get()[0].getElementsByTagName('input')[0].addEventListener('blur', this.setButtonFunctions);
  }
}
</script>
<style>
#prepareExpeditionModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

.btnDetailExpedition:hover, .btnPlanExpedition:hover,  .btnPrepareExpedition:hover, .btnEndExpedition:hover, .btnDisplayExpeditionLabels:hover, .btnDeleteExpedition:hover {
  color: var(--main-dark);
}
.btnPlannedExpedition:hover, .btnPreparedExpedition:hover, .btnExecutedExpedition:hover {
  color: var(--main-dark-50);
}
</style>